import React from 'react';
import BearriMotion from './BearriMotion';
import MotionMedia from './MotionMedia';
import type { BearriMotionAsset, BearriMotionName } from './motionAssets';
import './brandScenes.css';

/** A paper stage gives the mascot a place in the interface and a contact shadow. */
export default function MascotScene({
  name = 'thinking', className = '', playing = true, size = 'regular', asset,
}: { name?: BearriMotionName; className?: string; playing?: boolean; size?:'regular' | 'compact'; asset?:BearriMotionAsset }) {
  return (
    <div className={`br-mascot-scene br-mascot-scene--${size} ${className}`} aria-hidden="true">
      <span className="br-mascot-scene__sheet" />
      <span className="br-mascot-scene__floor" />
      <div className="br-mascot-scene__bear">
        {asset
          ? <MotionMedia asset={asset} playing={playing} className="h-full w-full object-contain" />
          : <BearriMotion name={name} playing={playing} className="h-full w-full object-contain" />}
      </div>
    </div>
  );
}
